import { useState } from "react";
import countries from "../../../assets/countries";
import languages from "../../../assets/languages";
import { Airline, Place, Salutation } from "../../../types";
import { SeparatorLine } from "../../SeparatorLine";
import { Modal, Button } from "react-bootstrap";
import { PhoneInput } from "../../PhoneInput";
import { getCountryCallingCode } from "react-phone-number-input";
import { useIntl } from "react-intl";
import dayjs from "dayjs";

export function StepEnterInfo({
	watch,
	register,
	errors,
	onSubmitRequest,
	salutations,
	places,
	airlines,
	setValue,
	reportCreating,
	showDialog,
	setShowDialog,
}: {
	watch: any;
	register: any;
	errors: any;
	onSubmitRequest: any;
	salutations: Salutation[];
	places: Place[];  
	airlines: Airline[];
	setValue: any;
	reportCreating: boolean;
	showDialog: boolean;
	setShowDialog: (show: boolean) => void;
}) {
	const intl = useIntl();

	// const [showDialog, setShowDialog] = useState(false);
	const airportPlane = watch("lossObjectAirplaneOrPlane");
	const country = watch("lossObjectCountry");

	// REVERTED FLAG IN QUERY
	const isPlane = places.find((f: Place) => f.LossPlace_ID == airportPlane)?.IsAirport;
	let countryCode = "41";
	try {
		countryCode = getCountryCallingCode(country);
	} catch (error) {
		console.log("error getting country code", error);
	}

	return (
		<div>
			<SeparatorLine />
			<h5 className="mb-2 mt-2 fw-bold" style={{ color: "#bc231e" }}>
				{intl.formatMessage({ id: "loss_report_edit_form_title" })}
			</h5>

			<div className="row mt-3">
				<div className="col-sm-12">
					<div className="form-group">
						<div className="input-group mb-3">
							<label
								htmlFor="salutation"
								className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
							>
								{intl.formatMessage({ id: "loss_report_salutation" })}
							</label>
							<div className="row col-12 col-md-9 col-lg-9">
								<select
									id="salutation"
									className={`form-select${errors.lossObjectSalutation ? " is-invalid" : ""} col-sm-6 rounded`}
									{...register("lossObjectSalutation")}
								>
									<option value="">Select</option>
									{salutations.map((opt) => (
										<option key={opt.Salutation_ID} value={opt.Salutation_ID}>
											{opt.LocalizedValue}
										</option>
									))}
								</select>
								{errors.lossObjectSalutation && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lossObjectSalutation.message as string}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-sm-12">
					<div className="form-group">
						<div className="input-group mb-3">
							<label
								htmlFor="firstName"
								className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
							>
								{intl.formatMessage({ id: "loss_report_first_name" })}
							</label>
							<div className="row col-12 col-md-9 col-lg-9">
								<input
									id="firstName"
									className={`form-control ${errors.lossObjectFirstName ? " is-invalid" : ""} rounded`}
									{...register("lossObjectFirstName")}
								/>
								{errors.lossObjectFirstName && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lossObjectFirstName.message as string}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-sm-12">
					<div className="form-group">
						<div className="input-group mb-3">
							<label
								htmlFor="lastName"
								className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
							>
								{intl.formatMessage({ id: "loss_report_last_name" })}
							</label>
							<div className="row col-12 col-md-9 col-lg-9">
								<input
									id="lastName"
									className={`form-control${errors.lossObjectLastName ? " is-invalid" : ""} rounded`}
									{...register("lossObjectLastName")}
								/>
								{errors.lossObjectLastName && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lossObjectLastName.message as string}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-sm-12">
					<div className="form-group">
						<div className="input-group mb-3">
							<label
								htmlFor="street"
								className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
							>
								{intl.formatMessage({ id: "loss_report_street" })}
							</label>
							<div className="row col-12 col-md-9 col-lg-9">
								<input
									id="street"
									className={`form-control${errors.lostObjectStret ? " is-invalid" : ""} rounded`}
									{...register("lostObjectStret")}
								/>
								{errors.lostObjectStret && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lostObjectStret.message as string}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-sm-12">
					<div className="form-group">
						<div className="input-group mb-3">
							<label
								htmlFor="zipAndCity"
								className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
							>
								{intl.formatMessage({ id: "loss_report_zipandplace" })}
							</label>

							<div className="col-4 col-md-3 col-lg-3">
								<input
									id="zip"
									className={`form-control ${errors.lossObjectZip ? " is-invalid" : ""} rounded`}
									{...register("lossObjectZip")}
								/>
								{errors.lossObjectZip && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lossObjectZip.message as string}
									</div>
								)}
							</div>
							<div className="col-8 col-md-6 col-lg-6 ps-2">
								<input
									id="city"
									className={`form-control ${errors.lossObjectPlace ? " is-invalid" : ""} rounded`}
									{...register("lossObjectPlace")}
								/>
								{errors.lossObjectPlace && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lossObjectPlace.message as string}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-sm-12">
					<div className="form-group">
						<div className="input-group mb-3">
							<label
								htmlFor="country"
								className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
							>
								{intl.formatMessage({ id: "loss_report_country" })}
							</label>
							<div className="row col-12 col-md-9 col-lg-9">
								<select
									id="country"
									className={`form-select${errors.lossObjectCountry ? " is-invalid" : ""} rounded`}
									defaultChecked="CH"
									{...register("lossObjectCountry")}
								>
									{countries.map((opt) => (
										<option key={opt.Value} value={opt.Value}>
											{opt.Name}
										</option>
									))}
								</select>
								{errors.lossObjectCountry && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lossObjectCountry.message as string}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-sm-12">
					<div className="form-group">
						<div className="input-group mb-3">
							<label
								htmlFor="tempAddress"
								className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
							>
								{intl.formatMessage({ id: "loss_report_temporaryaddress" })}
							</label>
							<div className="row col-12 col-md-9 col-lg-9">
								<textarea
									id="tempAddress"
									className="form-control rounded"
									rows={2}
									{...register("lossObjectTemporaryAddress")}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-sm-12">
					<div className="form-group">
						<div className="input-group mb-3">
							<label
								htmlFor="language"
								className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
							>
								{intl.formatMessage({ id: "loss_report_prefferedlanguage" })}
							</label>
							<div className="row col-12 col-md-9 col-lg-9">
								<select
									id="language"
									className={`form-select${errors.lossObjectPrefferedLanguage ? " is-invalid" : ""} rounded`}
									{...register("lossObjectPrefferedLanguage")}
								>
									{languages.map((opt) => (
										<option key={opt.Code} value={opt.Code}>
											{opt.Name}
										</option>
									))}
								</select>
								{errors.lossObjectPrefferedLanguage && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lossObjectPrefferedLanguage.message as string}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-sm-12">
					<div className="form-group">
						<div className="input-group mb-3">
							<label
								htmlFor="mobilePhone"
								className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
							>
								{intl.formatMessage({ id: "loss_report_mobilephone" })}
							</label>
							<div className="row col-12 col-md-9 col-lg-9">
								<PhoneInput
									placeholder={`+${countryCode} 123 456 78`}
									onChange={(val) => setValue("lossObjectMobilePhone", val)}
									defaultCountry={country || "CH"}
								/>
								{errors.lossObjectMobilePhone && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lossObjectMobilePhone.message as string}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-sm-12">
					<div className="form-group">
						<div className="input-group mb-3">
							<label
								htmlFor="privatePhone"
								className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
							>
								{intl.formatMessage({ id: "loss_report_privatephone" })}
							</label>
							<div className="row col-12 col-md-9 col-lg-9">
								<PhoneInput
									placeholder={`+${countryCode} 123 456 78`}
									onChange={(val) => setValue("lossObjectPrivatePhone", val)}
									defaultCountry={country || "CH"}
								/>
								{errors.lossObjectPrivatePhone && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lossObjectPrivatePhone.message as string}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-sm-12">
					<div className="form-group">
						<div className="input-group mb-3">
							<label
								htmlFor="email"
								className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
							>
								{intl.formatMessage({ id: "loss_report_email" })}
							</label>
							<div className="row col-12 col-md-9 col-lg-9">
								<input
									id="email"
									className={`form-control${errors.lossObjectEmail ? " is-invalid" : ""} rounded`}
									type="email"
									{...register("lossObjectEmail")}
								/>
								{errors.lossObjectEmail && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lossObjectEmail.message as string}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<SeparatorLine />
			<h5 className="mb-2 mt-4 fw-bold" style={{ color: "#bc231e" }}>
				{intl.formatMessage({ id: "loss_report_detailsofloss" })}
			</h5>

			<div className="row">
				<div className="col-sm-12">
					<div className="form-group">
						<div className="input-group mb-3">
							<label
								htmlFor="dateOfLoss"
								className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
							>
								{intl.formatMessage({ id: "loss_report_dateofloss" })}
							</label>
							<div className="row col-12 col-md-9 col-lg-9">
								<input
									id="dateOfLoss"
									className={`form-control${errors.lossObjectDateOfLoss ? " is-invalid" : ""} rounded`}
									type="date"
									min={dayjs().add(-3, "month").format("YYYY-MM-DD")}
									max={dayjs().format("YYYY-MM-DD")}
									{...register("lossObjectDateOfLoss")}
								/>
								{errors.lossObjectDateOfLoss && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lossObjectDateOfLoss.message as string}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-sm-12">
					<div className="form-group">
						<div className="input-group mb-3">
							<label
								htmlFor="salutation"
								className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
							>
								{intl.formatMessage({ id: "loss_report_zipandplace" })}
							</label>

							<div className="col-4 col-md-3 col-lg-3">
								<input
									id="zip"
									className={`form-control ${errors.lossObjectEnterpriseZip ? " is-invalid" : ""} rounded`}
									disabled
									{...register("lossObjectEnterpriseZip")}
								/>
								{errors.lossObjectEnterpriseZip && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lossObjectEnterpriseZip.message as string}
									</div>
								)}
							</div>
							<div className="col-8 col-md-6 col-lg-6 ps-2">
								<input
									id="place"
									disabled
									className={`form-control ${errors.lossObjectEnterprisePlace ? " is-invalid" : ""} rounded`}
									{...register("lossObjectEnterprisePlace")}
								/>
								{errors.lossObjectEnterprisePlace && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lossObjectEnterprisePlace.message as string}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-sm-12">
					<div className="form-group">
						<div className="input-group mb-3">
							<label
								htmlFor="airportPlane"
								className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
							>
								{intl.formatMessage({ id: "loss_report_airportplane" })}
							</label>
							<div className="row col-12 col-md-9 col-lg-9">
								<select
									id="airportPlane"
									className={`form-select${errors.lossObjectAirplaneOrPlane ? " is-invalid" : ""} rounded`}
									{...register("lossObjectAirplaneOrPlane")}
								>
									<option value="">Select place</option>
									{places
										.filter((f) => f.LossPlace_fk == null)
										.map((opt) => (
											<option key={opt.LossPlace_ID} value={opt.LossPlace_ID}>
												{opt.LocalizedValue}
											</option>
										))}
								</select>
								{errors.lossObjectAirplaneOrPlane && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lossObjectAirplaneOrPlane.message as string}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			{airportPlane != "" && !isPlane && (
				<div className="row">
					<div className="col-sm-12">
						<div className="form-group">
							<div className="input-group mb-3">
								<label
									htmlFor="placeDetail"
									className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
								>
									{intl.formatMessage({ id: "loss_report_place" })}
								</label>
								<div className="row col-12 col-md-9 col-lg-9">
									<select
										id="placeDetail"
										className={`form-select${errors.lossObjectAirplanePlace ? " is-invalid" : ""} rounded`}
										{...register("lossObjectAirplanePlace")}
									>
										<option value="">Select Place Details</option>
										{places
											.filter((f) => f.LossPlace_fk == airportPlane)
											.map((opt) => (
												<option key={opt.LossPlace_ID} value={opt.LossPlace_ID}>
													{opt.LocalizedValue}
												</option>
											))}
									</select>
									{errors.lossObjectAirplanePlace && (
										<div className="d-flex invalid-feedback d-block">
											{errors.lossObjectAirplanePlace.message as string}
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			)}

			{airportPlane != "" && isPlane ? (
				<>
					<div className="row">
						<div className="col-sm-12">
							<div className="form-group">
								<div className="input-group mb-3">
									<label
										htmlFor="airline"
										className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
									>
										{intl.formatMessage({ id: "loss_report_airline" })}
									</label>
									<div className="row col-12 col-md-9 col-lg-9">
										<select
											id="airline"
											className={`form-select${errors.lossObjectPlaneAirline ? " is-invalid" : ""} rounded`}
											{...register("lossObjectPlaneAirline")}
										>
											<option value="">Select Airline</option>
											{airlines
												.sort((a, b) => a.AirlineName.localeCompare(b.AirlineName))
												.map((opt) => (
													<option key={opt.UID} value={opt.UID}>
														{opt.AirlineName}
													</option>
												))}
										</select>
										{errors.lossObjectPlaneAirline && (
											<div className="d-flex invalid-feedback d-block">
												{errors.lossObjectPlaneAirline.message as string}
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-sm-12">
							<div className="form-group">
								<div className="input-group mb-3">
									<label
										htmlFor="flightNumber"
										className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
									>
										{intl.formatMessage({ id: "loss_report_flightnumber" })}
									</label>
									<div className="row col-12 col-md-9 col-lg-9">
										<input
											id="flightNumber"
											className={`form-select ${errors.lossObjectPlaneFlightNumber ? " is-invalid" : ""} rounded`}
											{...register("lossObjectPlaneFlightNumber")}
										/>
										{errors.lossObjectPlaneFlightNumber && (
											<div className="d-flex invalid-feedback d-block">
												{errors.lossObjectPlaneFlightNumber.message as string}
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-sm-12">
							<div className="form-group">
								<div className="input-group mb-3">
									<label
										htmlFor="flightDate"
										className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
									>
										{intl.formatMessage({ id: "loss_report_flightdate" })}
									</label>
									<div className="row col-12 col-md-9 col-lg-9">
										<input
											id="flightDate"
											className={`form-control${errors.lossObjectPlaneFlightDate ? " is-invalid" : ""} rounded`}
											type="date"
											min={dayjs().add(-3, "month").format("YYYY-MM-DD")}
											max={dayjs().format("YYYY-MM-DD")}
											{...register("lossObjectPlaneFlightDate")}
										/>
										{errors.lossObjectPlaneFlightDate && (
											<div className="d-flex invalid-feedback d-block">
												{errors.lossObjectPlaneFlightDate.message as string}
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
			) : (
				<></>
			)}

			<SeparatorLine />
			<h5 className="mb-2 mt-4 fw-bold" style={{ color: "#bc231e" }}>
				{intl.formatMessage({ id: "loss_report_describe_object" })}
			</h5>

			<div className="row mt-3">
				<div className="col-sm-12">
					<div className="form-group">
						<div className="input-group mb-3">
							<label
								htmlFor="description"
								className="col-12 col-md-3 col-lg-3 justify-content-start align-items-center d-flex form-label fw-bold"
							>
								{intl.formatMessage({ id: "loss_report_description" })}
							</label>
							<div className="row col-12 col-md-9 col-lg-9">
								<textarea
									id="description"
									className={`form-control${errors.lossObjectDescription ? " is-invalid" : ""} rounded`}
									rows={2}
									{...register("lossObjectDescription")}
								/>
								{errors.lossObjectDescription && (
									<div className="d-flex invalid-feedback d-block">
										{errors.lossObjectDescription.message as string}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="d-grid gap-2 d-md-flex justify-content-md-end mt-3">
				<button className="btn btn-primary" type="submit" disabled={reportCreating}>
					{intl.formatMessage({ id: "loss_report_btn_continue" })}
				</button>
			</div>

			{showDialog && (
				<ConfirmationDialog
					show={showDialog}
					handleClose={() => setShowDialog(false)}
					reportCreating={reportCreating}
					onConfirm={() => {
						onSubmitRequest();
					}}
				/>
			)}
		</div>
	);
}

function ConfirmationDialog({
	show,
	handleClose,
	onConfirm,
	reportCreating,
}: {
	show: boolean;
	handleClose: () => void;
	onConfirm: () => void;
	reportCreating: boolean;
}) {
	const intl = useIntl();

	const [agree, setAgree] = useState(false);
	return (
		<Modal show={show} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>{intl.formatMessage({ id: "loss_report_confirmation_title" })}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="row">
					<div className="col-3">{intl.formatMessage({ id: "loss_report_confirmation_subtitle" })}</div>
					<div className="col-9">
						<input type="checkbox" checked={agree} onChange={() => setAgree(!agree)} />
					</div>
				</div>
				<div className="row">
					<div className="col-3"></div>
					<div className="col-9">{intl.formatMessage({ id: "loss_report_confirmation_message" })}</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={handleClose}>
					{intl.formatMessage({ id: "loss_report_confirmation_close" })}
				</Button>
				<Button variant="primary" type="button" onClick={onConfirm} disabled={!agree || reportCreating}>
					{intl.formatMessage({ id: "loss_report_confirmation_confirm" })}
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
